export const getFormattedDate = timestamp => {
    let date = new Date(timestamp);
    if(date) {
        return date.toDateString();
    }
    return null;
}